module.exports = __webpack_public_path__ + "img/btn2.d7e67925.png";